import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import config from "./config";

const parseResponse = async (res) => {
  const text = await res.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch (_) {
    return { error: text };
  }
};

const getInvoiceLink = (payload) =>
  payload?.invoiceLink ||
  payload?.invoice_link ||
  payload?.receiptUrl ||
  payload?.receipt_url ||
  payload?.receiptLink ||
  payload?.receipt_link ||
  payload?.invoice?.link ||
  payload?.invoice?.url ||
  payload?.receipt?.link ||
  payload?.receipt?.url ||
  "";

export default function CompletionPage() {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState({ loading: true, error: "", data: null });
  const completionStartedRef = useRef(false);

  useEffect(() => {
    if (completionStartedRef.current) return;
    completionStartedRef.current = true;

    const session = searchParams.get("session") || sessionStorage.getItem("subscriptionSession");
    const storedSummary = JSON.parse(sessionStorage.getItem("subscriptionSummary") || "null");
    const phoneNumber =
      searchParams.get("phoneNumber") ||
      storedSummary?.phoneNumber ||
      storedSummary?.userId ||
      sessionStorage.getItem("subscriptionPhoneNumber");
    if (!session) {
      setState({ loading: false, error: "לא נמצא מזהה מנוי", data: null });
      return;
    }

    const body = {
      session,
      transaction_uid: searchParams.get("transaction_uid"),
      customer_uid: searchParams.get("customer_uid"),
      customer_email: searchParams.get("customer_email"),
      amount: searchParams.get("amount"),
      date: searchParams.get("date"),
      method: searchParams.get("method"),
      four_digits: searchParams.get("four_digits"),
      currency: searchParams.get("currency"),
      brand_name: searchParams.get("brand_name"),
      more_info: searchParams.get("more_info"),
      phoneNumber,
      userId: phoneNumber,
      syncToDevice: true,
    };

    fetch(`${config.apiUrl}/api/public-subscriptions/complete`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        const json = await parseResponse(res);
        if (!res.ok) throw new Error(json?.error || "שמירת המנוי נכשלה");
        const forcedUserId = phoneNumber || json.data?.phoneNumber || json.data?.userId || "";
        const data = {
          ...storedSummary,
          ...json.data,
          phoneNumber: forcedUserId,
          userId: forcedUserId,
          invoiceLink: getInvoiceLink(json.data) || getInvoiceLink(json),
        };
        sessionStorage.removeItem("subscriptionSession");
        sessionStorage.removeItem("subscriptionPaymentLink");
        setState({ loading: false, error: "", data });
      })
      .catch((err) => setState({ loading: false, error: err.message, data: null }));
  }, [searchParams]);

  const invoiceLink = state.data?.invoiceLink || state.data?.receiptUrl;

  return (
    <main className="page" dir="rtl">
      <section className="panel">
        <img src="/logo.png" alt="Blue Parking" className="logo" />
        {state.loading ? (
          <>
            <h1>מעדכן מנוי...</h1>
            <p>נא להמתין לסיום השמירה</p>
          </>
        ) : state.error ? (
          <>
            <h1>התשלום התקבל אך המנוי לא נשמר</h1>
            <p className="error">{state.error}</p>
            <Link to="/">חזרה להתחלה</Link>
          </>
        ) : (
          <>
            <h1>המנוי הופעל בהצלחה</h1>
            <div className="receipt">
              <div><span>טלפון / מזהה משתמש</span><strong>{state.data?.phoneNumber || state.data?.userId}</strong></div>
              <div><span>רכב</span><strong>{state.data?.carId}</strong></div>
              <div><span>חניון</span><strong>{state.data?.placeName}</strong></div>
              <div><span>סכום</span><strong>{state.data?.amount} ₪</strong></div>
              <div><span>תחילת מנוי</span><strong>{new Date(state.data?.startDate).toLocaleDateString("he-IL")}</strong></div>
              <div><span>בתוקף עד</span><strong>{new Date(state.data?.endDate).toLocaleDateString("he-IL")}</strong></div>
            </div>
            {invoiceLink ? (
              <button type="button" onClick={() => window.open(invoiceLink, "_blank", "noopener,noreferrer")}>
                קבלה
              </button>
            ) : null}
            <Link to="/">מנוי נוסף</Link>
          </>
        )}
      </section>
    </main>
  );
}
